__turbopack_context__.v({
  "board": "StreamingBoard-module__wdQleq__board",
  "content": "StreamingBoard-module__wdQleq__content",
  "header": "StreamingBoard-module__wdQleq__header",
  "pendingTask": "StreamingBoard-module__wdQleq__pendingTask",
});
